import * as React from 'react';
import { IReceiptConfirmationProps } from './ProcessCreditNoteDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import ReceiptConfirmationForm from './ProcessCreditNoteDialog.form';
import { showSnackBar } from 'components/common/SnackBars/SnackBar.hooks';

const ProcessCreditNoteDialog = (props: IReceiptConfirmationProps): JSX.Element => {
  const {
    open, values, printCreditNoteDocumentOutputOptions, printDocketDocumentOutputOptions,
    setPrintCreditNoteDocumentOutputOptions, setPrintDocketDocumentOutputOptions, onOk: onApply,
    onCancel, initialValues, currentUserId, formSyncErrors, isProcessing
  } = props;

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        isDefault: true,
        disabled: !!isProcessing,
        listener: () => {
          if (isValidFormData()) {
            onApply({
              ...values,
              SortOption: '',
              OutputCreditNote: values?.PrintCredit,
              Transmit: values?.TransmitCreditNote,
              OutputDocket: values?.PrintDocketCreditNote,
              CreditNoteOutput: { ...printCreditNoteDocumentOutputOptions },
              DocketOutput: { ...printDocketDocumentOutputOptions },
            });
          }
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          onCancel();
        }
      }
    ];
  };

  React.useEffect(
    () => {
      if (open && initialValues) {
        setPrintCreditNoteDocumentOutputOptions(initialValues?.inlineObject?.CreditNoteOutput);
        setPrintDocketDocumentOutputOptions(initialValues?.inlineObject?.DocketOutput);
      }
    },
    [open, initialValues]);

  const isValidFormData = (): boolean => {
    if (formSyncErrors && Object.keys(formSyncErrors).length > 0) {
      const requiredError = Object.entries(formSyncErrors).find((item) => item.includes('Required'));
      if (requiredError) {
        showSnackBar({ variant: 'warning', message: 'Please fill in required fields.' });
      } else {
        const firstError = Object.keys(formSyncErrors)[0];
        showSnackBar({ variant: 'warning', message: `Please enter valid ${firstError}` });
      }

      return false;
    }

    return true;
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title={'Credit Note Confirmation'}
    formProps={{
      style: {
        height: '585px',
        minWidth: '535px'
      },
      formSchema: ReceiptConfirmationForm,
      initialValues: {
        ...initialValues?.inlineObject,
        UserId: currentUserId,
        PrintCredit: initialValues?.inlineObject?.OutputCreditNote ?? true,
        PrintDocketCreditNote: initialValues?.inlineObject?.OutputDocket ?? false,
        TransmitCreditNote: initialValues?.inlineObject?.Transmit ?? false,
      },
      valuesSchema: initialValues ? initialValues?.schema : {},
      fieldExtensions: {
        ...(values?.AlertMessage && {
          AlertMessage: {
            text: values?.AlertMessage,
            customStyles: {
              color: '#a07800',
              background: '#ffedb8',
              padding: '10px',
              marginBottom: '15px',
              borderRadius: '5px',
            },
          },
        }),
        PrintCredit: {
          disabled: initialValues?.inlineObject?.OutputCreditNoteReadOnly ?? false,
        },
        PrintDocketCreditNote: {
          disabled: initialValues?.inlineObject?.OutputDocketReadOnly ?? false,
        },
        TransmitCreditNote: {
          disabled: initialValues?.inlineObject?.TransmitReadOnly ?? false,
        },
        TransmitVia: {
          disabled: initialValues?.inlineObject?.TransmitViaReadOnly ?? false,
        },
      }
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}
  />);
};

export default ProcessCreditNoteDialog;
